import { render, staticRenderFns } from "./ContentDashboard.vue?vue&type=template&id=e713f22e&scoped=true"
import script from "./ContentDashboard.vue?vue&type=script&lang=js"
export * from "./ContentDashboard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e713f22e",
  null
  
)

export default component.exports